import React from "react";
import styles from "./loader.module.css";

type Size = "xs" | "sm" | "md" | "lg";

type LoadingSpinnerProps = {
  size?: Size; // visual size of the spinner
  label?: string; // optional text to show next to/below spinner
  inline?: boolean; // inline layout (no overlay/padding)
  overlay?: boolean; // absolute overlay inside a relatively positioned parent
  fullscreen?: boolean; // fixed overlay covering the entire viewport
  className?: string; // additional class for container
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  label,
  inline = false,
  overlay = false,
  fullscreen = false,
  className,
}) => {
  const containerClasses = [
    styles.loader,
    inline && styles.inline,
    overlay && styles.overlay,
    fullscreen && styles.fullscreen,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const innerClasses = [
    styles.loaderInner,
    size === "xs" && styles.sizeXs,
    size === "sm" && styles.sizeSm,
    size === "md" && styles.sizeMd,
    size === "lg" && styles.sizeLg,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={containerClasses}
      role="status"
      aria-live="polite"
      aria-busy
    >
      <div className={innerClasses} />
      {label && <div className={styles.label}>{label}</div>}
    </div>
  );
};
export default LoadingSpinner;
